<template>
  <div :id="id" class="row align-items-center">
    <LmTextInput
      ref="inputFocus"
      :id="`label-${id}`"
      class="col-12 col-md-8"
      v-model="component.componentProps.label"
      @input="onLabelChange($event)"
      :label="$t('title')"
      :placeholder="$t('title')"
      :help="$t('comp_title_help')"
    />

    <LmTextInput
      v-if="validateSuperUser"
      class="col-12 col-md-4"
      :id="id + 'nombre'"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
      :label="$t('name')"
      :placeholder="$t('name')"
      :help="$t('comp_name_help')"
    />

    <LmTextInput
      ref="inputLabelGroup"
      :id="`label-group-${id}`"
      class="col-12 col-md-6"
      v-model="component.componentProps.labelGroup"
      @input="$emit('input', component)"
      :label="$t('title_group')"
      :placeholder="$t('title_group')"
    />
    <LmCheckbox
      class="col-12 col-md-6"
      :labelSingle="$t('comp_numeration')"
      v-model="component.componentProps.isLabelGroupNumber"
      @input="$emit('input', component)"
    />

    <LmTextInput
      ref="inputTextButton"
      :id="`button-text-${id}`"
      class="col-12 col-md-6"
      v-model="component.componentProps.buttonText"
      @input="$emit('input', component)"
      :label="$t('button_text')"
      :placeholder="$t('button_text')"
    />

    <LmTextInput
      class="col-12 col-md-8"
      :id="id + 'help'"
      v-model="component.componentProps.help"
      @input="$emit('input', component)"
      :label="$t('helper_text_setter')"
      :placeholder="$t('helper_text_setter')"
      :help="$t('helper_text_setter_help')"
    />

    <div class="col-12">
      <hr class="w-100">
      <div class="mb-2"> </div>
      <draggable
        class="col-12"
        v-model="form.formElements"
        @start="drag=true"
        @end="drag=false"
        animation="150"
        handle=".handle"
        >
        <div v-for="(formElement, index) in form.formElements" :key="index" class="mt-3">
          <header  class="d-flex justify-content-between align-items-center bg-info text-white px-3 handle shadow rounded-lg">
            <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
            <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-repeat-${index}`">{{title(form.formElements[index])}}</h6>
            <div class="circle d-flex justify-content-center align-items-center">{{index}}</div>
            <div class="d-flex align-items-center">
              <font-awesome-icon v-b-toggle="`collapse-repeat-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
              <font-awesome-icon  class="ml-4 clickable" icon="trash" style="width:16px; height:16px;" @click="removeElement(index)" />
            </div>
          </header>

          <b-collapse
           :id="`collapse-repeat-${index}`"
          class="p-4 border border-top-0 rounded-lg"
          >
            <component
              :ref="`componentRef${index}`"
              :is="whatComponentBuilderUse(form.formElements[index].componentName)"
              :componentData="form.formElements[index]"
              :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
              :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
              :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
              :validationsData="formElement.validations"
              :options="lmSuperPowerSelectV2BuilderUiOptions"
              :isVisibleCondition="false"
              :index="index"
              @validations-changes="onValidationsChange($event, index)"
            />
            <template v-if="!componentIsEditable">
              <hr class="w-100">
              <b-row>
                <LmCheckbox
                  class="col-12"
                  labelSingle="Permite edición por usuario"
                  v-model="formElement.componentProps.isEditableByPickedUser"
                />
              </b-row>
            </template>
            <template v-if="showPropertiesForPdf">
              <hr class="w-100">
              <section class="row">
                <h4 class="col-12">Propiedades para el PDF</h4>
                <LmCheckbox
                  :disabled="formElement.hasLabelOnPdf"
                  class="col-12"
                  labelSingle="Ocultar al generar el PDF"
                  v-model="formElement.isHiddenOnPdf"
                />
                <LmCheckbox
                  :disabled="formElement.isHiddenOnPdf"
                  class="col-12"
                  labelSingle="Incluir título del campo en el PDF"
                  v-model="formElement.hasLabelOnPdf"
                />
              </section>
            </template>
          </b-collapse>
        </div>
      </draggable>

      <LmSelect
      id="select-elements-0"
      label="Campo a repetir"
      class="mt-3"
      v-model="elementTypeOption"
      :options="repeatFieldsComponentsOptions"
      />

      <LmButton
      buttonClass="btn-primary mb-1 "
      lmButtonWrapperClass="col-1"
      lmButtonRootWrapperClass="d-block col-1 p-0"
      :disabled="elementTypeOption === ''"
      type= 'button'
      :value="$t('add')"
      @click.native="agregar"
      />

      <hr class="w-100 mt-4">
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
    </div>

  </div>
</template>

<script>

import draggable from 'vuedraggable'
import commonsApi from '@/api/commons'

import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
import LmSelect from '@/components/form/elements/LmSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmRadioBuilderUi from '@/components/lmFormBuilderUi/LmRadioBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmTreeSelectBuilderUi from '@/components/lmFormBuilderUi/LmTreeSelectBuilderUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmEditorBuilderUi from '@/components/lmFormBuilderUi/LmEditorBuilderUi'
import LmTagsInputBuilderUi from '@/components/lmFormBuilderUi/LmTagsInputBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCodeInputBuilderUi from '@/components/lmFormBuilderUi/LmCodeInputBuilderUi'
import LmPageBreakBuilderUi from '@/components/lmFormBuilderUi/LmPageBreakBuilderUi'
import LmReaderInputBuilderUi from '@/components/lmFormBuilderUi/LmReaderInputBuilderUi'

import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'

export default {
  mixins: [lmFormElementsBuilderUiMixin, lmFormBuilderUi],
  components: {
    LmConditionalBuilderUi,
    LmSelect,
    LmTextInput,
    LmCheckbox,
    LmButton,
    draggable,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmColorPickerBuilderUi,
    LmCommentBuilderUi,
    LmCheckboxBuilderUi,
    LmRadioBuilderUi,
    LmTreeSelectBuilderUi,
    LmUploadFilesBuilderUi,
    LmEditorBuilderUi,
    LmTagsInputBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCodeInputBuilderUi,
    LmPageBreakBuilderUi,
    LmReaderInputBuilderUi
  },
  data () {
    return {
      component: {},
      elementTypeOption: '',
      listToRepeat: [],
      form: {
        formElements: []
      },
      repeatFieldsComponentsOptions: {
        disabledOption: 'Seleccione una opción',
        content: []
      }
    }
  },

  computed: {
    componentIsEditable () {
      return Boolean(this.componentData?.componentProps?.isEditableByPickedUser)
    }
  },

  methods: {
    // Hago una sincronizacion entre los items del form y las validaciones
    onValidationsChange (event, index) {
      /*
        Envio la validacion de cada componente dentro de si mismo y no en un objeto por separado
        Esto evita tener que crear un generador de watchers para evitar la insercion erronea de propiedades
        Ejemplo: si escribo de name "dni", obtenia por cada letra un objeto con las validaciones
        d: {...}, dn: {...}, dni: {..}
      */
      for (const validation in event) {
        this.form.formElements[index].validations = event[validation]
      }
    },
    agregar () {
      let index = this.form.formElements.length

      // pasa nombre del componente y index
      this.selectorElementForm(this.elementTypeOption, index, 'LmRepeatFieldsBuilderUi')
    },
    removeElement (index) {
      this.form.formElements.splice(index, 1)
    },
    title (component) {
      const componentLabel = component?.componentProps?.label
      const componentValue = component?.componentProps?.value
      const componentText = component?.componentProps?.text
      const { text } = this.repeatFieldsComponentsOptions.content.find(e => e.value === component?.componentName)
      let moreInfo = ''
      if (componentLabel) {
        moreInfo += ' - ' + componentLabel
      } else if (componentValue) {
        moreInfo += ' - ' + componentValue
      } else if (componentText) {
        moreInfo += ' - ' + componentText
      }
      return text + moreInfo
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    showPropertiesForPdf: {
      type: Boolean
    }
  },
  watch: {
    componentData () {
      // Escucha componentData que se envía de LmFormBuilderUi
      this.component = this.$refs.componentReff0.componentData.componentProps
    },
    componentIsEditable (val) {
      if (val === true) {
        this.form.formElements.forEach((element) => {
          element.componentProps.isEditableByPickedUser = false
        })
      }
    }
  },
  async created () {
    // Seteo los componentes como opciones del selector
    const options = await commonsApi.axiosGetWrapper('/codificator/61f1987a99fdef4d94c81e3e')
    const items = { content: [] }
    for (const opt in options.data.options) {
      items.content.push({
        value: options.data.options[opt].value,
        text: options.data.options[opt].text
      })
    }
    this.repeatFieldsComponentsOptions.content = items.content

    if (this.component?.componentProps?.initialItems?.formElements) {
      this.form = this.component.componentProps.initialItems
    }

    if (!this.form.formElements.length) {
      this.selectorElementForm('LmTextInput', 0, 'LmRepeatFieldsBuilderUi')
    }
  }
}
</script>

<style scoped>
.circle {
  background: white;
  color: black;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  text-align: center;
}
</style>
